<div class="flex flex-wrap justify-end gap-4 filters-wrapper">
  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="issuerName"
    type="text"
    placeholder="Search by company name"
    class="border-b text-sm border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, 'issuerName')"
  />
  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="cikNumber"
    type="text"
    placeholder="Search by cik number"
    class="border-b text-sm border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, 'cikNumber')"
  />
</div>

<div class="mb-4"></div>

<p-table
  [value]="processedIssuers"
  [paginator]="processedIssuers.length > 0"
  [first]="first"
  (onLazyLoad)="loadData($event)"
  [lazy]="true"
  [totalRecords]="paginator.totalCount"
  [rows]="paginator.pageSize"
  [loading]="isLoading"
  [showCurrentPageReport]="true"
  [tableStyle]="{ 'min-width': '50rem' }"
  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  (onPage)="pageChange($event)"
  [(selection)]="selectedIssuers"
  dataKey="asReportedIssuerId"
  [rowsPerPageOptions]="[10, 25, 50]"
>
  <ng-template #header>
    <tr>
      <th>CIK</th>
      <th>Issuer Name(s)</th>
    </tr>
  </ng-template>
  <ng-template #body let-issuer>
    <tr>
      <td>{{ issuer.cik || "N/A" }}</td>
      <td>{{ issuer.issuerNames?.length ? issuer.issuerNames.join(' | ') : 'N/A' }}</td>
    </tr>
  </ng-template>
</p-table>
<p-toast></p-toast>

<ng-container *ngIf="!isLoading && processedIssuers.length === 0">
  <div class="text-center py-6 text-gray-500">No record found.</div>
</ng-container>

